"use client";
import { useIsMobile } from "@/app/Hooks/useIsMobile";
import { HomepageTopAd, MobileAdUnit } from "../../AdsBox/AdsBox";
import LeftComponent from "./LeftComponent";
import RightComponent from "./RightComponent";

const HomePageSubSection = ({
  leftSideData,
  rightSideData,
  leftSideTitle,
  rightSideTitle,
}) => {
  const isMobile = useIsMobile();

  const design = (
    <>
      {isMobile ? <MobileAdUnit /> : <HomepageTopAd />}
      <div className="grid grid-cols-12 gap-4 md:gap-10">
        <div className="col-span-12 lg:col-span-7">
          <LeftComponent leftSideData={leftSideData} title={leftSideTitle} />
        </div>

        <div className="col-span-12 lg:col-span-5">
          <RightComponent
            rightSideData={rightSideData}
            title={rightSideTitle}
          />
        </div>
      </div>
    </>
  );
  return design;
};

export default HomePageSubSection;
